import React, { Component } from "react";

import edit from "../images/editgreen.svg";
import Delete from "../images/delete.svg";
import license from "../assets/license.png";
import CustomButton from "../components/CustomButton";
import moment from "moment-timezone";
import momentjalali from "moment-jalaali";

export default class RestaurantItem extends Component {
  constructor(props) {
    super(props);
    let title = "";
    let descr = "";
    this.props.info.forEach((element) => {
      if (element.languageId === this.props.defaultLanguage) {
        title = element.name;
        descr = element.descr;
      }
    });
    this.state = {
      title: title,
      descr: descr,
      expireTime: "",
    };
  }

  componentDidMount() {
    var zone_name = moment.tz.guess();
    let newdatetime = moment
      .tz(this.props.expireTime, zone_name)
      .format("yyyy-MM-DD HH:mm")
      .toString()
      .split(" ");
    this.setState({
      expireTime: momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD"),
    });
  }

  onEdit() {
    this.props.onEdit(this.props.code, this.props.id);
  }

  onDelete() {
    this.props.onDelete(this.props.id, this.state.title);
  }

  clickItem() {
    this.props.onClick(this.props.code, this.props.id);
  }

  onBuyLicenseClick() {
    this.props.onLicenseClick(this.props.code);
  }

  render() {
    return (
      <div className="RestaurantItem">
        <img
          src={this.props.img}
          alt=""
          style={{
            objectFit: "cover",
            height: "76px",
            width: "76px",
            borderRadius: "7px",
          }}
        />
        {/* className="ResItemTextsContainer" */}
        <div
          className="ResItemTextsContainer"
          style={{
            justifyContent: this.state.des !== "" ? "flex-start" : "center",
          }}
        >
          <div
            className="ResItemTitle"
            style={{ marginBottom: this.state.des !== "" ? "3px" : "0px" }}
          >
            {this.state.title}
          </div>
          {this.state.des !== "" && (
            <div className="ResItemDes">{this.state.des}</div>
          )}
        </div>

        <div
          onClick={this.clickItem.bind(this)}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            left: "0",
            top: "0",
          }}
        />
        <div className="ResItemButtonContainer">
          {/* <div className="ResItemButton" style={{color:'var(--brown2)'}}>
                        <div style={{width:'16px',height:'12px',display:'flex',justifyContent:'center',alignItems: 'center',marginRight:'3px'}}><img src={Order} alt="" style={{maxHeight:'100%',maxWidth:'100%'}} /></div>
                        <div className="ResItemButtonTitle">{this.props.orderNum} OR</div>
                    </div> */}
          <div
            className="ResItemButton"
            style={{
              color: "var(--brown2)",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "4px",
              }}
            >
              <div
                style={{
                  height: "16px",
                  maxWidth: "16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={license}
                  alt=""
                  style={{ height: "100%", objectFit: "contain" }}
                />
              </div>
            </div>
            {this.props.subscriptionType !== 3 && (
              <div>{this.state.expireTime}</div>
            )}
            {this.props.subscriptionType === 3 && (
              <CustomButton
                title="خرید اشتراک"
                whiteSpace="noWrap"
                minHeight="15px"
                fontSize="9px"
                onClick={this.onBuyLicenseClick.bind(this)}
              />
            )}
          </div>
          {this.props.subscriptionType !== 3 && (
            <div
              className="ResItemButton"
              style={{ color: "var(--green1)", marginBottom: "10px" }}
              onClick={this.onEdit.bind(this)}
            >
              <div
                style={{
                  height: "16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "4px",
                }}
              >
                <div
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={edit}
                    alt=""
                    style={{ height: "75%", objectFit: "contain" }}
                  />
                </div>
              </div>
              <div>ویرایش</div>
            </div>
          )}
          <div
            className="ResItemButton"
            style={{ color: "var(--brown3)" }}
            onClick={this.onDelete.bind(this)}
          >
            <div
              style={{
                height: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "4px",
              }}
            >
              <div
                style={{
                  height: "20px",
                  width: "20px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <img
                  src={Delete}
                  alt=""
                  style={{ width: "90%", height: "85%", objectFit: "contain" }}
                />
              </div>
            </div>
            <div>حذف</div>
          </div>

          {/* <div
            className="ResItemButton"
            style={{ color: "var(--brown3)" }}
            onClick={this.onDelete.bind(this)}
          >
            <div
              style={{
                height: "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "4px",
              }}
            >
              <div
                style={{
                  height: "20px",
                  width: "20px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <img
                  src={Delete}
                  alt=""
                  style={{ width: "90%", height: "85%", objectFit: "contain" }}
                />
              </div>
            </div>
            <div>{this.state.smsCredit}</div>
          </div> */}
        </div>
      </div>
    );
  }
}
